import { useState } from "react";
import { useDispatch } from "react-redux";
import { userTypes } from "../../../utils/helpers/constants";
import { filterData } from "../../../utils/helpers/dataHelper";
import AntTable from "./AntTable";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import { showModal } from "../../../actions/modal.action";
import ModalTypesEnum from "../../../utils/mapper/enums/ModalTypesEnum";

export default function Body({ profile, list, loading, deleteStatusState }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [filterKey, setFilterKey] = useState("");

  const handleModal = () => {
    dispatch(showModal(ModalTypesEnum.DELIVERY_FEE_REQUEST, ""));
  };

  const handleEdit = (payload) => {
    dispatch(showModal(ModalTypesEnum.DELIVERY_FEE_EDIT_REQUEST, payload));
  };

  const handleSearch = (value) => {
    setFilterKey(value);
  };

  return (
    <div className="">
      <div className="mx-2 md:container md:mx-auto">
        <AiOutlineArrowLeft
          size={25}
          onClick={() => history.goBack()}
          className="mt-2 cursor-pointer"
        />
        {[profile["userType"]] === userTypes.ROLE_USER ? null : (
          <div className="page-header">
            <div>
              <h1 className="page-title">Delivery Fee</h1>
            </div>
          </div>
        )}
        <div className="p-2">
          <AntTable
            handleSearch={(value) => handleSearch(value)}
            list={filterData(list, filterKey, ["name", "code"])}
            statusState={loading}
            handleCreate={() => handleModal()}
            handleEdit={(item) => handleEdit(item)}
            deleteStatusState={deleteStatusState}
          />
        </div>
      </div>
    </div>
  );
}
